import * as Yup from 'yup'


Yup.addMethod(Yup.string, "valida_patente", function (errorMessage) {
    return this.test(`valida_patente`, errorMessage, function (patente) {
        if (patente && patente.length > 0) {
            //var regex = /^[a-z]{2}[\.\- ]?[0-9]{2}[\.\- ]?[0-9]{2}|[b-d,f-h,j-l,p,r-t,v-z]{2}[\-\. ]?[b-d,f-h,j-l,p,r-t,v-z]{2}[\.\- ]?[0-9]{2}$/i;
            var regex = /^[a-z]{2}[\.\- ]?[0-9]{2}[\.\- ]?[0-9]{2}|[b-d,f-h,j-l,p,r-t,v-z]{2}[\-\. ]?[b-d,f-h,j-l,p,r-t,v-z]{2}[\.\- ]?[0-9]{2}|[a-zA-Z]{2,3}[0-9]{3}|[a-zA-Z]{3}[0-9]{2}[a-zA-Z]{1}$/i;
            if (regex.test(patente)) {
                return true;
            } else {
                return false;
            }
        }
     
        return true;
  })
})
export const validationSchemas = (isDias, isFechas) => {
  let validationObject = { };
  if (isFechas) {
    validationObject["fechadesde"] = Yup.string().required('El campo es obligatorio.');
    validationObject["fechahasta"] = Yup.string().required('El campo es obligatorio.');
    validationObject["fechadesde"] = Yup.date().max(Yup.ref('fechahasta'), 'Fecha desde debe ser menor a la fecha hasta.');
    validationObject["fechahasta"] = Yup.date().max(new Date(), 'Fecha hasta no puede ser mayor a la fecha actual.');
    validationObject["criterioFecha"] = Yup.string().required('Este campo es obligatorio');
  }

  return Yup.object().shape(validationObject);
}

